<div class="machine-container">
  @if (pictogram) {
    <img class="machine-image" [width]="48" [height]="48" [ngSrc]="pictogram" [alt]="rowData.displayName" />
  }
  <span class="ellipsis" [pTooltip]="rowData.displayName" geauiTooltipOnEllipsisV2>
    {{ rowData.displayName }}
  </span>
</div>
